module.exports = __webpack_public_path__ + "static/media/exit.88bb4bdf.webp";